class CampaignsModel {
    private _freespins: Freespins;
    private hasBeenCleared: boolean = false;
    private hasShownPrompt: boolean = false;

    public isFreespinsActive() {
        return this.freespins && !this.hasBeenCleared && (this.freespins.remaining > 0 || !this.hasBeenCleared);
    }

    public shouldUpdateDisplay() {
        return this.freespins && this.freespins.remaining >= 0;
    }

    public clear() {
        this.freespins.remaining = 0;
        this.freespins.isComplete = false;
        this.hasBeenCleared = true;
    }

    public getHasShownPrompt = () => this.hasShownPrompt;
    public setHasShownPrompt = (val: boolean) => this.hasShownPrompt = val;

    public get freespins() { return this._freespins; }
    public set freespins(val) {
        this._freespins = val;
        this.hasBeenCleared = false;
    }
}

export class Freespins {
    public total: number;
    public remaining: number;
    public totalWin: number ;
    public isComplete: boolean;
    public betLevel: number;
    public coinLevel: number;
    public awardId: string;
    public awardType: number;
    public campaignId: number;
    public useBefore: string;
    public type: string;
}

export default new CampaignsModel();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/model/campaigns-model.ts